import { Box, styled } from '@mui/material';

const StatusBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  justify-content: flex-end;
`;

export default StatusBox;
